<template>
  <el-dialog
    class="order-return-detail-modal"
    width="90%"
    title="退款明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div v-for="o in list" :key="o.id" class="order-return">
      <div class="field">
        <label>退款单号</label>
        <div>{{ o.returnSn }}</div>
      </div>
      <div class="field">
        <label>申请时间</label>
        <div>{{ o.createTime | dateTimeFmt }}</div>
      </div>
      <div class="field">
        <label>退款原因</label>
        <div>{{ o.memoApply }}</div>
      </div>
      <div class="field">
        <label>退款状态</label>
        <div>{{ o.state === 4 ? '已处理' : '退款中' }}</div>
      </div>
      <div class="field">
        <label>退款金额</label>
        <div>{{ o.amountReturn ? o.amountReturn.toLocaleString() : '--' }}</div>
      </div>
      <div class="field">
        <label>退款时间</label>
        <div>{{ o.timeDeal | dateTimeFmt }}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { OrderItemReturnInfo } from '../services'
export default {
  name: 'OrderReturnDetailModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      list: []
    }
  },
  methods: {
    init (orderItemId) {
      this.loadData(orderItemId)
      return this.open()
    },
    loadData (orderItemId) {
      this.loading = true
      OrderItemReturnInfo(orderItemId).then((resp) => {
        this.list = resp
      }).catch(() => {
        this.$message.error('加载退款记录信息失败')
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.order-return-detail-modal
  .el-dialog
    max-width 768px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .order-return
        .field
          display flex
          flex-direction row
          label
            width 70px
            flex-shrink 0
            text-align right
            font-size bold
            &:after
              content: '\ff1a'
          >div
            word-break break-all
        +.order-return
          margin-top 10px
          padding-top 10px
          border-top 1px dashed #d4d4d4
</style>
